import { BvtFeatureFlags, withBvtFlagChecker } from '@utils/bvt-feature-flags';
import { YPSLandingUplift } from '../yps-landing-uplift/index-lazy';
import { YPSLanding } from '../yps-landing-page/index-lazy';

const YPSLandingHome = withBvtFlagChecker(
    YPSLandingUplift, // New page if flag is ON
    YPSLanding, // Old page (Fallback) if flag is OFF
    { bvtFlagName: BvtFeatureFlags.YPSLandingAble }
);

export default YPSLandingHome;
